<nz-result nzStatus="error" nzTitle="500" nzSubTitle="Error! Server Error"
  [nzIcon]="icon">
  <div nz-result-extra>
    <p>An error occurred trying to process your request, Please try again later</p>
  </div>
</nz-result>
<ng-template #icon>
  <i nz-icon nzType="warning" nzTheme="fill"></i>
</ng-template>
